/* global LOCIZE_API_KEY */
/* global GLUUTEN_API_KEY */

import i18n from 'i18next'

import Backend from 'i18next-chained-backend';
import GluutenBackend from '@gluuten/i18next-gluuten-backend'
import postProcessor from 'i18next-sprintf-postprocessor'
import LanguageDetector from 'i18next-browser-languagedetector'

const locale = 'et'

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(postProcessor)

let locizeConfig = {
  projectId: '01d84bd4-013e-4107-8e35-553dd8110bf2',
  referenceLng: 'en'
}

let gluutenConfig = {
  projectId: "e879a79e-d4f4-4e3c-bd51-7dd0efd000ac",
  referenceLng: 'en'
}

if(typeof LOCIZE_API_KEY !== 'undefined' && LOCIZE_API_KEY) {
  locizeConfig.apiKey = LOCIZE_API_KEY
}

if(typeof GLUUTEN_API_KEY !== 'undefined' && GLUUTEN_API_KEY) {
  gluutenConfig.apiKey = GLUUTEN_API_KEY
}

export const i18nOptions = {
  debug: false,
  fallbackLng: 'en',
  returnEmptyString: false,
  lng: locale, // use language variable here
  keySeparator: '##',
  nsSeparator: '#!!#', // we don't use these things
  defaultNS: 'translation',
  ns: 'translation',
  saveMissing: !!gluutenConfig.apiKey,
  backend: {
    backends: [
      // LocalStorageBackend,  // primary
      GluutenBackend,        // fallback
    ],
    backendOptions: [
      // {
      //   // prefix for stored languages
      //   prefix: 'i18next_res_',
      //
      //   // expiration
      //   expirationTime: 24*60*60*1000,
      //
      //   // language versions
      //   versions: {}
      // },
      gluutenConfig]
  },
};

export const init = (options={}) => {
  i18n.init({...i18nOptions, ...options})
};

export const getDefaultLanguage = () => ({
  value: 'et',
  country: 'ee',
  label: i18n.t('Estonian')
});
export const getLanguages = () => {
  return {
    'en-gb': {
      value: 'en-gb',
      country: 'gb',
      label: i18n.t('English')
    },
    // 'en': {
    //   value: 'en',
    //   label: i18n.t('English (Am)')
    // },
    'et': {
      value: 'et',
      country: 'ee',
      label: i18n.t('Estonian')
    },
    'ru': {
      value: 'ru',
      country: 'ru',
      label: i18n.t('Russian')
    },
    'fi': {
      value: 'fi',
      country: 'fi',
      label: i18n.t('Finnish')
    },
  }
};

export default i18n
export const __ = i18n.t.bind(i18n);
